<!--
 * @Descripttion: 修改了一些内容
 * @version: v1.0
 * @Author: htt
 * @Date: 2021-09-24 14:31:20
 * @LastEditors: htt
 * @LastEditTime: 2021-12-02 09:34:20
-->
<template>
  <div class="step">
    <el-steps
      :active="current"
      finish-status="success"
      simple
      :process-status="active===current?'process':'finish'"
      finishd-status="success"
      @change="changeValue(current)"
    >
      <el-step :status="getStepStatus(idx)" :title="item.title" v-for="(item,idx) in steps" :key="idx" @click.native="stepChange(idx)" />
<!--      <el-step title="场地楼层维护" @click.native="stepChange(2)" />
      <el-step title="场地信息维护" @click.native="stepChange(3)" />
      <el-step title="机位信息维护" @click.native="stepChange(4)" />
      <el-step title="监控信息维护" @click.native="stepChange(5)" />-->
    </el-steps>
    <div v-show="current===0" class="info-base">
      <el-form ref="ruleFormref" :model="ruleForm" :rules="rules" label-width="150px" class="base-form" label-position="right">
        <el-form-item label="场地联系人：" prop="linkMan">
          <el-input v-model.trim="ruleForm.linkMan" clearable maxlength="20" />
        </el-form-item>
        <el-form-item label="所属交易中心：" prop="tradeOrgId">
          <el-select v-model="ruleForm.tradeOrgId" :disabled="ruleForm.tradeOrgId!=''" clearable filterable  placeholder="请选择" @change="onOrgsChange">
            <el-option
              v-for="item in tradeOrgIdOptions"
              :key="item.id"
              :label="item.orgName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系方式：" prop="linkPhone">
          <el-input
            v-model.trim="ruleForm.linkPhone"
            clearable
            maxlength="20"
          />
        </el-form-item>

        <el-form-item label="备注：" prop="remark">
          <el-input
              type="textarea"
              :rows="5"
            v-model.trim="ruleForm.remark"
            clearable
            maxlength="20"
          />
        </el-form-item>
      </el-form>
    </div>
    <div v-show="current===1" class="info-base">
      <div>
        楼层信息：
        <el-button size="small" type="primary" icon="el-icon-plus" @click="openUpdatefloor()">新增楼层</el-button>
      </div>
      <div class="info-base-table over">
        <el-table
          :data="floorData"
          border
          style="width: 100%"
          :header-cell-style="{
            background:'#D9E1E7',
            color:'#000'
          }"
          align="center"
          >
          <el-table-column
            label="序号"
            width="50"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="floorName"
            label="楼层名称"
            align="center"
          />
          <el-table-column
            prop="floorLevel"
            label="楼层数值"
            align="center"
          />
          <el-table-column
            label="操作"
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="openUpdatefloor(scope.row.id)">修改</el-button>
              <el-button type="text" @click="handleFloorDelete(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <pagination
            v-show="floorTotal>7"
            class="limit"
            :page-sizes="[7, 14, 21, 28,35]"
            :total="floorTotal"
            :page.sync="floorQuery.page"
            :limit.sync="floorQuery.limit"
            @pagination="getFloorData"
          />
        </div>
      </div>
    </div>
    <div v-show="current===2" class="info-base">
      <div>
        场地信息：
        <el-button size="small" type="primary" icon="el-icon-plus" @click="openUpdate()">新增场地</el-button>
      </div>
      <div class="info-base-table over">
        <el-table
          :data="bidData"
          border
          style="width: 100%"
          :header-cell-style="{
            background:'#D9E1E7',
            color:'#000'
          }"
          align="center"
          >
          <el-table-column
            label="序号"
            width="50"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="场地名称"
            align="center"
          />
          <el-table-column
            prop="code"
            label="场地编号"
            align="center"
          />
          <el-table-column
            prop="fieldTypeName"
            label="场地类型"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="sort"
            label="排序"
            align="center"
          />
          <el-table-column
            prop="floorName"
            label="场地楼层"
            align="center"
          />
          <el-table-column
            prop="machines"
            label="机位数"
            align="center"
          />
          <el-table-column
            prop="openSeats"
            label="已开启机位数"
            align="center"
          />
          <el-table-column
            prop="camerasNum"
            label="监控数"
            align="center"
          />
          <el-table-column
            prop="openCameras"
            label="已开启监控数"
            align="center"
          />
          <el-table-column
            label="操作"
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="openUpdate(scope.row.id)">修改</el-button>
              <el-button type="text" @click="handleDelete(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <pagination
            v-show="bidTotal>7"
            class="limit"
            :page-sizes="[7, 14, 21, 28,35]"
            :total.sync="bidTotal"
            :page.sync="bidQuery.page"
            :limit.sync="bidQuery.limit"
            @pagination="getBidData"
          />
        </div>
      </div>
    </div>
    <div v-show="current===3" class="info-base">
      <div>
        机位信息：<el-button size="small" type="primary" icon="el-icon-plus" @click="openSeatUpdate()">新增机位</el-button>
      </div>
      <div class="info-base-table over">
        <el-table
          :data="seatData"
          border
          style="width: 100%"
          :header-cell-style="{
            background:'#D9E1E7',
            color:'#000'
          }"
          align="center"
        >
          <el-table-column
            label="序号"
            width="50"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="fieldName"
            label="场地名称"
            align="center"
          />
          <el-table-column
            prop="seatName"
            label="机位名称"
            align="center"
          />
          <el-table-column
            prop="seatCode"
            label="机位编号"
            align="center"
          />
          <el-table-column
            prop="seatMac"
            label="机位物理地址"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            prop="seatStatus"
            label="状态"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.seatStatus == 0" class="open">启用</span>
              <span v-if="scope.row.seatStatus == 1" class="close">停用</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="openSeatUpdate(scope.row.id)">修改</el-button>
              <el-button type="text" @click="handleSeatDelete(scope.row.id)">删除</el-button>
              <el-button v-if="scope.row.seatStatus ===0" type="text" @click="handleSeatClose(scope.row)">停用</el-button>
              <el-button v-else type="text" @click="handleSeatClose(scope.row)">启用</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <pagination
            v-show="seatTotal>7"
            class="limit"
            :page-sizes="[7, 14, 21, 28,35]"
            :total="seatTotal"
            :page.sync="seatQuery.page"
            :limit.sync="seatQuery.limit"
            @pagination="getSeatData"
          />
        </div>
      </div>
    </div>
    <div v-show="current===4" class="info-base">
      <div>
        监控信息：
        <el-button size="small" type="primary" icon="el-icon-plus" @click="openMonitorUpdate()">新增监控</el-button>
      </div>
      <div class="info-base-table over">
        <el-table
          :data="monitorData"
          border
          style="width: 100%"
          :header-cell-style="{
            background:'#D9E1E7',
            color:'#000'
          }"
          align="center"
        >
          <el-table-column
            label="序号"
            width="50"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="fieldName"
            label="场地名称"
            align="center"
          />
          <el-table-column
            prop="cameraName"
            label="监控名称"
            align="center"
          />
          <el-table-column
            prop="cameraCode"
            label="监控编号"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            prop="cameraUrl"
            label="监控地址"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            prop="sort"
            label="排序"
            align="center"
          />
          <el-table-column
            prop="status"
            label="状态"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0" class="open">启用</span>
              <span v-if="scope.row.status == 1" class="close">停用</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="openMonitorUpdate(scope.row.id)">修改</el-button>
              <el-button type="text" @click="handleMonitorDelete(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <pagination
            v-show="monitorTotal>7"
            class="limit"
            :page-sizes="[7, 14, 21, 28,35]"
            :total="monitorTotal"
            :page.sync="monitorQuery.page"
            :limit.sync="monitorQuery.limit"
            @pagination="getMonitorData"
          />
        </div>
      </div>
    </div>
    <div class="steps-action step-btn">
      <el-button :disabled="current===0" @click="prev">
        上一步
      </el-button>
      <el-button
        v-if="current < steps.length - 1"
        type="primary"
        :loading="btnload"
        @click="next"
      >
        下一步
      </el-button>
      <el-button
        v-if="current == steps.length - 1"
        type="primary"
        @click="finish"
      >
        完成
      </el-button>

      <el-button @click="backTo">
        返回列表
      </el-button>
    </div>
    <!-- <div class="step-btn">
      <el-button :disabled="current===0" @click="pre">上一步</el-button>
      <el-button v-if="current<3" type="primary" :loading="btnload" @click="next">下一步</el-button>
      <el-button v-if="current===3" type="primary" @click="finish">完成</el-button>
    </div> -->
  </div>
</template>
<script>
import { infoBaseSave } from '@/server/field'
import { checkPhone } from '@/utils/validate'
import Pagination from "@/components/Pagination";
export default {
  components: {
    // InfoDetail
    Pagination
  },
  props: {
    steps: {
      type: Array,
      required: true
    },
    stepList: {
      type: Array,
      required: true
    },
    ruleForm: {
      type: Object,
      default: function() {
        return {
          tradeOrgId: '',
          tradeOrgName: '',
          regionCode: '',
          linkMan: '',
          linkPhone: '',
          remark:''
        }
      }
    },
    bidData: {
      type: Array,
      required: true
    },
    bidTotal: {
      type: Number,
      required: true
    },
    bidQuery: {
      type: Object,
      required: true
    },

    floorData: {
      type: Array,
      required: true
    },
    floorTotal: {
      type: Number,
      required: true
    },
    floorQuery: {
      type: Object,
      required: true
    },
    seatData: {
      type: Array,
      required: true
    },
    seatTotal: {
      type: Number,
      required: true
    },
    seatQuery: {
      type: Object,
      required: true
    },
    monitorData: {
      type: Array,
      required: true
    },
    monitorTotal: {
      type: Number,
      required: true
    },
    monitorQuery: {
      type: Object,
      required: true
    },
    flag: {
      type: Boolean,
      required: true
    }
  },
  data() {
    // const checkPhone = (rule, value, callback) => {
    //   // 验证手机号的正则表达式
    //   const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
    //   if (regMobile.test(value)) {
    //     return callback()
    //   }
    //   callback(new Error('请输入合法的手机号'))
    // }
    return {
      current: 0,
      status: 'process',
      active: 0,
      allStepts: false,
      btnload: false,
      // ruleForm: {
      //   tradeOrgId: vm.$store.state.user.userinfo.orgInfo.orgId,
      //   linkMan: '',
      //   linkPhone: ''
      // },
      rules: {
        linkMan: [
          { required: true, message: '请输入场地联系人', trigger: 'blur' }
        ],
        tradeOrgId: [
          { required: true, message: '请选择所属交易中心', trigger: ['blur','change'] }
        ],
        linkPhone: [
          { required: true, validator: checkPhone, trigger: 'blur' }
        ],
        remark: [
          { max: 100,min:1, trigger: 'blur',message:"长度不能超过100个字符" }
        ]
      },
      orgId: '',
      result: [],
      unfinedSteps: [],
      tradeOrgIdOptions:[]
    }
  },
  watch: {
    current(val) {
      this.active = val
      if (val === 1) {
        // 获取场地数据
        this.getFloorData()
      } if (val === 2) {
        // 获取场地数据
        this.getBidData()
      } else if (val === 3) {
        // 获取机位数据
        this.getSeatData()
      } else if (val === 4) {
        // 获取监控数据
        this.getMonitorData()
      }
    },
    stepList:{
      immediate: true,
      handler (val) {
        this.unfinedSteps=JSON.parse(JSON.stringify(val))
        this.current = this.unfinedSteps.length>0?this.unfinedSteps[0]:0;
      },
      deep: true
    },
  },
  activated() {
    // 重置节点位置
    this.current = this.unfinedSteps.length>0?this.unfinedSteps[0]:0;
    this.gettradeOrgData();
    // this.getSteps()
  },
  methods: {
    getStepStatus(idx){
      return this.unfinedSteps.includes(idx)?'process':this.active==idx?'finish':'success'
    },
    // 步骤条上一步的方法
    // pre() {
    //   if (this.active-- < 2) this.active = 0
    // },
    prev() {
      if (this.current>0){
        this.current--
      }

    },
    next() {
      if (this.current === 0) {
        this.btnload = true
        this.$refs['ruleFormref'].validate((valid,invalidFields) => {
          console.log("校验结果1：",invalidFields)
          if (valid) {
            // this.active++
            infoBaseSave(this.ruleForm).then(res => {
              if (res.data.code === '1') {
                this.$message.success(res.data.msg)
                setTimeout(() => {
                  this.btnload = false
                  // this.active++

                  removeStep(this.current,this)
                  this.current++

                }, 500)
              } else {
                this.$message.error(res.data.msg)
                this.btnload = false
              }
            })
          } else {
            this.btnload = false
            return false
          }
        })
      } else{
        if (this.current<this.steps.length-1){
          removeStep(this.current,this)
          this.current++
        }
      }

      function removeStep(step,obj){
        let idx=obj.unfinedSteps.indexOf(step)
        if (idx<0){
          return
        }
        console.log("index:",idx)
        obj.unfinedSteps=obj.unfinedSteps.splice(idx+1,obj.unfinedSteps.length-1)
        if (obj.unfinedSteps.length<1){
          obj.unfinedSteps.push(step+1)
        }
        console.log("unfinish2:",obj.unfinedSteps)
      }
    },
    changeValue() {
    },
    stepChange(current) {
      // 当前点击的先转string类型去查询是否存在；存在后转回number类型去跳转对应节点
      if (this.flag === true && !this.unfinedSteps.includes(current)) {
        this.current = current
      }
    },
    // 完成
    finish() {
      console.log("触发finish")
      this.current = 0
      this.active = 0
    },
    backTo(){
      this.$router.push({name:'fieldmglist'})
      this.removeTabHandle("fieldmg-config")
    },
    // 获取场地数据
    getBidData() {
      this.$emit('getBidData')
    },
    // 场地编辑
    openUpdate(id) {
      this.$emit('openUpdate', id)
    },
    // 场地删除
    handleDelete(id) {
      this.$emit('handleDelete', id)
    },

    // 获取场地楼层数据
    getFloorData() {
      this.$emit('getFloorData')
    },
    // 场地楼层编辑
    openUpdatefloor(id) {
      this.$emit('openUpdatefloor', id)
    },
    // 场地楼层删除
    handleFloorDelete(id) {
      this.$emit('handleFloorDelete', id)
    },
    // 获取机位数据
    getSeatData() {
      this.$emit('getSeatData')
    },
    // 机位编辑
    openSeatUpdate(row) {
      this.$emit('openSeatUpdate', row)
    },
    // 机位删除
    handleSeatDelete(row) {
      this.$emit('handleSeatDelete', row)
    },
    // 机位状态
    handleSeatClose(row) {
      this.$emit('handleSeatClose', row)
    },
    // 获取监控数据
    getMonitorData() {
      this.$emit('getMonitorData')
    },
    // 监控编辑
    openMonitorUpdate(row) {
      this.$emit('openMonitorUpdate', row)
    },
    // 监控删除
    handleMonitorDelete(row) {
      this.$emit('handleMonitorDelete', row)
    },
    gettradeOrgData(){
      this.$http.post('/config/loadTrades?regionCode='+process.env.VUE_APP_REGION,{}).then((data)=>{
        this.tradeOrgIdOptions=data.data.data;
      })
      
    },
    onOrgsChange(val){
      let items=this.tradeOrgIdOptions.filter(x=>x.id==val);
      this.ruleForm.tradeOrgName=items&&items.length>0?items[0].orgName:""
      this.ruleForm.regionCode=items&&items.length>0?items[0].regionCode:""
    }
  }
}
</script>
<style lang="scss" scoped>
.step{
  /deep/.ant-steps-item-icon{
    height:30px;
    width: 30px;
    line-height: 30px;
  }
  .step-list{
    padding: 0 200px;
  }
  .info-base{
    // height: 216px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #D8D8D8;
    // margin:32px;
    margin:24px 32px 24px 32px;
    padding:20px 32px 8px 32px;
    .open:before{
      content: '';
      position: absolute;
      width: 6px;
      height: 6px;
      background: #2568EC;
      border-radius: 50%;
      top: 20px;
      margin-left: -10px;
    }
    .close:before{
      content: '';
      position: absolute;
      width: 6px;
      height: 6px;
      background: #F23030;
      border-radius: 50%;
      top: 20px;
      margin-left: -10px;
    }
    .base-form{
      width: 44%;
      margin: 0 auto;
    }
    .info-base-table{
      margin:16px 0px 16px 55px
    }
    .over{
      margin: 16px 0px 16px 70px;
    }

  }
  .step-btn{
    width: 350px;
    margin: 0 auto;
  }
  /deep/.is-success{
    color: #2568EC;
    border-color: #2568EC;
  }
  /deep/.el-step__title.is-success{
    color: rgba(0, 0, 0, 0.85);
  }
  /deep/.is-finish{
     color:#fff;
     border:none;
    // color: #c0c4cc;
    // border-color: #c0c4cc;
  }
  /deep/.is-finish>.el-step__icon.is-text{
    background:#2568EC
  }
  /deep/.el-step__title.is-finish{
    color: rgba(0, 0, 0, 0.85);
  }
  /deep/.is-wait>.el-step__icon.is-text{
    color:#fff
  }
  /deep/.is-wait>.el-step__icon:before {
    content: ">";
    color:#ccc;
    position: absolute;
    top:3px
  }
   /deep/.el-step__head>.el-step__line{
    // margin:0 30px!important;
    margin-left: 30px;
    margin-right: 10px!important;
  }
}

</style>
